const methods = [{
  'shortname': 'IMP',
  'name': 'Hormonal implant',
  'altName': 'Implant',
  'category': 'implant',
  'tags': ['woman', 'implant', 'years'],
  'period': 5,
  'score': 1,
  'cyp': 3.8,
  'doses': 0,
  'eng': 'Implant',
  'swa': 'Vipandikizi'
}, {
  'shortname': 'VAS',
  'name': 'male surgical sterilization',
  'altName': 'Vasectomy',
  'category': 'sterilization',
  'tags': ['man', 'permanent'],
  'score': 0.33,
  'cyp': 10,
  'doses': 0,
  'eng': 'Vasectomy',
  'swa': 'Vasektomi'
}, {
  'shortname': 'LNG-IUD',
  'name': 'levonorgestrel-releasing intrauterine device',
  'altName': 'Coil',
  'category': 'iud',
  'tags': ['woman', 'years'],
  'period': 5,
  'score': 0.25,
  'cyp': 3.3,
  'doses': 0,
  'eng': 'Coil',
  'swa': 'Kitanzi'
}, {
  'shortname': 'TL',
  'name': 'female surgical sterilization',
  'altName': 'Tubal Ligation',
  'category': 'sterilization',
  'tags': ['woman', 'permanent'],
  'score': 0.1,
  'cyp': 10,
  'doses': 0,
  'eng': 'Tubal ligation (TL)',
  'swa': 'Kufunga kizazi mwanamke'
}, {
  'shortname': 'Cu-IUD',
  'name': 'copper-bearing intrauterine device',
  'altName': 'Coil',
  'category': 'iud',
  'tags': ['woman', 'ecp', 'years'],
  'period': 12,
  'score': 0.0625,
  'cyp': 4.6,
  'doses': 0,
  'eng': 'Copper I U C D',
  'swa': 'Copper I U C D'
}, {
  'shortname': 'CIC',
  'name': 'combined injectable contraceptive',
  'altName': 'Monthly Injectable',
  'category': 'combined hormonal contraceptive',
  'tags': ['woman', 'days', 'injectable'],
  'period': 30,
  'score': 0.008,
  'cyp': 0,
  'doses': 13,
  'eng': 'Monthly injectable',
  'swa': 'Sindano'
}, {
  'shortname': 'INJ',
  'name': 'Progeston-only injectable',
  'altName': 'Injectable',
  'category': 'progestogen-only injectable',
  'tags': ['woman', 'weeks', 'injectable'],
  'period': 12,
  'score': 0.008,
  'cyp': 0,
  'doses': 6,
  'eng': 'Injectable',
  'swa': 'Sindano baada ya kila miezi mitatu'
}, {
  'shortname': 'COC',
  'name': 'combined oral contraceptive',
  'altName': 'Pill',
  'category': 'combined hormonal contraceptive',
  'tags': ['woman', 'days', 'pill'],
  'period': 28,
  'score': 0.005,
  'cyp': 0,
  'doses': 15,
  'eng': 'The pill',
  'swa': 'Vidonge vyenye vichocheo viwili'
}, {
  'shortname': 'P',
  'name': 'combined contraceptive patch',
  'altName': 'Patch',
  'category': 'combined hormonal contraceptive',
  'tags': ['woman', 'days'],
  'period': 7,
  'score': 0.005,
  'cyp': 0,
  'doses': 15,
  'eng': 'The patch',
  'swa': 'Kibandiko'
}, {
  'shortname': 'CVR',
  'name': 'combined contraceptive vaginal ring',
  'altName': 'Ring',
  'category': 'combined hormonal contraceptive',
  'tags': ['woman', 'days'],
  'period': 21,
  'score': 0.005,
  'cyp': 0,
  'doses': 15,
  'eng': 'The ring',
  'swa': 'Pete ndani ya uke'
}, {
  'shortname': 'POP',
  'name': 'progestogen-only pill',
  'altName': 'Minipill',
  'category': 'progestogen-only pill',
  'tags': ['woman', 'days', 'pill'],
  'period': 28,
  'score': 0.005,
  'cyp': 0,
  'doses': 15,
  'eng': 'Minipill',
  'swa': 'Vidonge vyenye kichocheo kimoja'
}, {
  'shortname': 'ECPs',
  'name': 'Emergency contraception pills',
  'altName': 'Emergency contraception pills',
  'category': 'emergency contraception',
  'tags': ['woman', 'ecp'],
  'score': 0.001,
  'cyp': 0,
  'doses': 0,
  'eng': 'Emergency contraception',
  'swa': 'Tembe za dharura'
}, {
  'shortname': 'condomM',
  'name': 'Male condoms',
  'altName': 'Male condoms',
  'category': 'barrier methods',
  'tags': ['man', 'days'],
  'score': 0.002,
  'cyp': 0,
  'doses': 120,
  'eng': 'Male condoms',
  'swa': 'Kondomu ya kiume'
}, {
  'shortname': 'condomF',
  'name': 'Female condoms',
  'altName': 'Female condoms',
  'category': 'barrier methods',
  'tags': ['woman', 'days'],
  'score': 0.002,
  'cyp': 0,
  'doses': 120,
  'eng': 'Female condoms',
  'swa': 'Kondomu ya kike'
}, {
  'shortname': 'diaphragm',
  'name': 'Diaphragm',
  'altName': 'Diaphragm',
  'category': 'barrier methods',
  'tags': ['woman', 'days'],
  'score': 0.004,
  'cyp': 0,
  'doses': 120,
  'eng': 'Diaphragm',
  'swa': 'Kiwambo'
}, {
  'shortname': 'ecConsult',
  'name': 'Emergency contraception consultation',
  'altName': 'Emergency contraception consultation',
  'category': 'counseling',
  'tags': ['woman', 'nomethod', 'ecp'],
  'score': 0.0015,
  'cyp': 0,
  'doses': 0,
  'eng': 'Emergency contraception consultation',
  'swa': 'Ushauri wa tembe za dharura'
}, {
  'shortname': 'pp_ConsultTL',
  'name': 'Consultation about postpartum tubal ligation',
  'altName': 'Consultation about postpartum tubal ligation',
  'category': 'counseling',
  'tags': ['woman', 'postpartum'],
  'score': 0.0009,
  'cyp': 0,
  'doses': 0,
  'eng': 'Consultation about postpartum tubal ligation',
  'swa': 'Ushauri wa kufunga mishipa baada ya kujifungua'
}, {
  'shortname': 'pp_ConsultCon',
  'name': 'Consultation about postpartum family planning',
  'altName': 'Consultation about postpartum family planning',
  'category': 'counseling',
  'tags': ['woman', 'postpartum'],
  'score': 0.0008,
  'cyp': 0,
  'doses': 0,
  'eng': 'Consultation about postpartum family planning',
  'swa': 'Ushauri wa upangaji uzazi baada ya kujifungua'
}, {
  'shortname': 'pp_ConsultLAM',
  'name': 'Consultation about postpartum lactational amenorrhoea method',
  'altName': 'Consultation about postpartum lactational amenorrhoea method',
  'category': 'counseling',
  'tags': ['woman', 'postpartum'],
  'score': 0.0007,
  'cyp': 0,
  'doses': 0,
  'eng': 'Consultation about postpartum lactational amenorrhoea method',
  'swa': 'Ushauri wa kujikinga kupata mimba kwa kunyonyesha baada ya kujifungua'
}]

export default class MethodMap {
  static getMap () {
    return methods.reduce((map, cur, idx, orig) => {
      map[cur.shortname] = cur
      return map
    }, {})
  }
}



// WEBPACK FOOTER //
// ./src/components/CreateSmsApp/methods.js